const CATEGORIES = [
  {
    name: "Tops",
    children: [
      {
        name: "Blazer",
        conditions: {
          type: "Blazer"
        }
      },
      {
        name: "Hoodie",
        conditions: {
          type: "Hoodie"
        }
      },
      {
        name: "Jackets",
        conditions: {
          type: "Jackets"
        }
      },
      {
        name: "Shirt",
        conditions: {
          type: "Shirt"
        }
      },
      {
        name: "Sweater",
        conditions: {
          type: "Sweater"
        }
      },
      {
        name: "Sweatshirt",
        conditions: {
          type: "Sweatshirt"
        }
      },
      {
        name: "Tees",
        conditions: {
          type: "Tees"
        }
      },
      {
        name: "Vest",
        conditions: {
          type: "Vest"
        }
      }
    ]
  },
  {
    name: "Bottoms",
    children: [
      {
        name: "Jeans",
        conditions: {
          type: "Jeans"
        }
      },
      {
        name: "Jorts",
        conditions: {
          type: "Jorts"
        }
      },
      {
        name: "Pants",
        conditions: {
          type: "Pants"
        }
      },
      {
        name: "Shorts",
        conditions: {
          type: "Shorts"
        }
      },
      {
        name: "Sweatpants",
        conditions: {
          type: "Sweatpants"
        }
      }
    ]
  },
  {
    name: "Footwear",
    children: [
      {
        name: "Boots",
        conditions: {
          type: "Boots"
        }
      },
      {
        name: "Casual Shoes",
        conditions: {
          type: "Casual Shoes"
        }
      },
      {
        name: "Sneakers",
        conditions: {
          type: "Sneakers"
        }
      }
    ]
  },
  {
    name: "Accessories",
    children: [
      {
        name: "Belt",
        conditions: {
          type: "Belt"
        }
      },
      {
        name: "Bracelets",
        conditions: {
          type: "Bracelets"
        }
      },
      {
        name: "Hat",
        conditions: {
          type: "Hat"
        }
      },
      {
        name: "Necklaces",
        conditions: {
          type: "Necklaces"
        }
      },
      {
        name: "Rings",
        conditions: {
          type: "Rings"
        }
      },
      {
        name: "Socks",
        conditions: {
          type: "Socks"
        }
      }
    ]
  },
  {
    name: "Set",
    conditions: {
      type: "Set"
    }
  },
  {
    name: "Gift",
    conditions: {
      type: "Gift"
    }
  },
  {
    name: "Price Difference",
    conditions: {
      type: "Price Difference"
    }
  }
];
class GooglePixelInstance {
  constructor() {
    this.brand = "thesupermade";
    this.currency = Shopify.currency.active;
    this._getListProducts();
    window.subscribe(window.PUB_SUB_EVENTS.listRenderCompleted, (event) => {
      this._getListProducts();
      if (event == null ? void 0 : event.source) {
        this._handleItemListEvent(event.source);
      }
    });
    const appearList = document.querySelectorAll(`[data-pixel-list-appear="true"]`);
    appearList.forEach((element) => {
      this._handleItemListEvent(element);
    });
    const template = document.documentElement.dataset.template;
    if (template === "product") {
      const jsonScript = document.querySelector(`[id^="json-product-"][type="application/json"]`);
      if (jsonScript) {
        const productData = JSON.parse(jsonScript.textContent);
        const params = new URLSearchParams(window.location.search);
        const variantId = params.get("variant");
        this._handleViewItem(
          productData,
          `product_details_${jsonScript.dataset.productId}`,
          "Product details",
          variantId
        );
      }
    } else if (template === "cart") {
      this._handleViewCart({
        source: "cart"
      });
    }
    this._handleItemListAppear();
    this._handleViewItemListUpdate();
    this._handleCartUpdate();
    this._handleWishlistUpdate();
    this._handleSelectItemDelegation();
    document.body.addEventListener("cartDrawerOpened", (event) => {
      var _a;
      this._handleViewCart({
        source: "cart-drawer"
      });
      const source = (_a = event.detail) == null ? void 0 : _a.source;
      const pixelList = source == null ? void 0 : source.querySelectorAll(`[data-pixel-list]`);
      if (pixelList == null ? void 0 : pixelList.length) {
        pixelList.forEach((element) => {
          this._handleItemListEvent(element);
        });
      }
    });
    document.body.addEventListener("productCardModalOpened", (event) => {
      const { product, pixel } = event.detail;
      if (product) {
        this._handleViewItem(product, pixel.id, pixel.name);
      }
    });
  }
  _centsToMajor(cents) {
    return typeof cents === "number" ? cents / 100 : (parseFloat(cents) || 0) / 100;
  }
  _getListProducts() {
    const jsonScripts = document.querySelectorAll(`[data-name="json-pixel-products"][type="application/json"]`);
    this.listProducts = Array.from(jsonScripts).reduce((acc, cur) => {
      try {
        const products = JSON.parse(cur.textContent) || [];
        return [...acc, ...products];
      } catch (e) {
        return acc;
      }
    }, []);
  }
  _crateEventItems({ accum = 0, items = [], listId = "none", listName = "none" }) {
    const filerItems = items == null ? void 0 : items.filter(
      (item) => item !== null && Object.prototype.toString.call(item) === "[object Object]"
    );
    if (!(filerItems == null ? void 0 : filerItems.length))
      return [];
    return filerItems.map((item, index) => {
      var _a, _b, _c;
      const selectedVariant = ((_a = item.variants) == null ? void 0 : _a.find((v) => v.selected === true)) || ((_b = item.variants) == null ? void 0 : _b.find((v) => v.available === true)) || ((_c = item.variants) == null ? void 0 : _c[0]) || {};
      const categories = this._createCategories(item);
      return {
        item_id: selectedVariant.id,
        item_name: item.title,
        index: accum + (item.pixelIndex ? Number(item.pixelIndex) : index + 1),
        item_list_id: listId,
        item_list_name: listName,
        item_variant: selectedVariant.title,
        item_brand: this.brand,
        price: this._centsToMajor(selectedVariant.price),
        quantity: 1,
        ...categories,
        item_category4: item.type || "none",
        item_category5: item.vendor
      };
    });
  }
  async _crateEventCartItems(cartItems = [], listId = "none", listName = "none") {
    const filerItems = cartItems == null ? void 0 : cartItems.filter(
      (item) => item !== null && Object.prototype.toString.call(item) === "[object Object]"
    );
    if (!(filerItems == null ? void 0 : filerItems.length))
      return [];
    const urls = [];
    const cartMapping = {};
    filerItems.forEach((item) => {
      var _a, _b;
      urls.push(`${window.Shopify.routes.root}products/${item.handle}.js`);
      item.calc_discount = ((_a = item.discounts) == null ? void 0 : _a.reduce((acc, cur) => acc + cur.amount, 0)) || 0;
      const coupon = ((_b = item.discounts) == null ? void 0 : _b.map((d) => d.title)) || [];
      item.calc_coupon = [...new Set(coupon)].join(";");
      cartMapping[item.product_id] = item;
    });
    const results = await window.fetchWithConcurrencyLimit(urls);
    const items = results.map((item, index) => {
      const cartItem = cartMapping[item.id];
      const categories = this._createCategories(item);
      return {
        item_id: cartItem == null ? void 0 : cartItem.variant_id,
        item_name: cartItem == null ? void 0 : cartItem.title,
        index: (cartItem == null ? void 0 : cartItem.update_index) ? Number(cartItem == null ? void 0 : cartItem.update_index) : index + 1,
        item_list_id: listId || "none",
        item_list_name: listName || "none",
        item_variant: cartItem == null ? void 0 : cartItem.variant_title,
        item_brand: this.brand,
        price: this._centsToMajor(cartItem == null ? void 0 : cartItem.final_price),
        quantity: (cartItem == null ? void 0 : cartItem.update_quantity) ? Number(cartItem == null ? void 0 : cartItem.update_quantity) : Number(cartItem == null ? void 0 : cartItem.quantity),
        ...categories,
        item_category4: (cartItem == null ? void 0 : cartItem.product_type) || "none",
        item_category5: (cartItem == null ? void 0 : cartItem.vendor) || "none",
        discount: this._centsToMajor((cartItem == null ? void 0 : cartItem.calc_discount) || 0),
        coupon: (cartItem == null ? void 0 : cartItem.calc_coupon) || "none"
      };
    });
    return items;
  }
  _createCategories(item) {
    const cascadeMenu = [];
    const itemType = (item == null ? void 0 : item.type) || item.product_type || "";
    for (let category of CATEGORIES) {
      if (category.children) {
        const findChildren = category.children.find((c) => {
          var _a;
          return ((_a = c.conditions) == null ? void 0 : _a.type) === itemType;
        });
        if (findChildren) {
          cascadeMenu.push(category.name, findChildren.name);
        }
      } else if (category.conditions) {
        if (category.conditions.type === itemType) {
          cascadeMenu.push(category.name);
        }
      }
    }
    const categories = {};
    for (let i = 1; i <= 3; i++) {
      categories["item_category" + (i === 1 ? "" : i)] = cascadeMenu[i - 1] || categories["item_category" + (i - 1 === 1 ? "" : i - 1)] || "none";
    }
    return categories;
  }
  async _handleViewCart({ source }) {
    let cartData = {};
    const jsonScript = document.querySelector(`[id^="json-cart"][type="application/json"]`);
    if (jsonScript) {
      cartData = JSON.parse(jsonScript.textContent);
    }
    const cartItems = cartData.items || [];
    const items = await this._crateEventCartItems(cartItems, source, source === "cart" ? "Cart" : "Cart drawer");
    gtag("event", "view_cart", {
      currency: this.currency,
      value: this._centsToMajor(cartData.total_price),
      items
    });
  }
  _handleCartUpdate() {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, async (event) => {
      var _a;
      const pixel = event.pixel || {};
      if (!((_a = pixel.items) == null ? void 0 : _a.length))
        return;
      const items = await this._crateEventCartItems(pixel.items, pixel.listId, pixel.listName);
      const eventName = ["plus", "add"].includes(pixel.buttonName) ? "add_to_cart" : "remove_from_cart";
      gtag("event", eventName, {
        currency: this.currency,
        value: this._centsToMajor(pixel.value),
        button_name: pixel.buttonName,
        items
      });
    });
  }
  _handleWishlistUpdate() {
    window.subscribe(window.PUB_SUB_EVENTS.wishlistUpdate, (event) => {
      var _a;
      const { product, variant, pixel } = event;
      if (product) {
        const productVariant = (_a = product.variants) == null ? void 0 : _a.find((v) => v.id === (variant == null ? void 0 : variant.id));
        if (productVariant) {
          productVariant.selected = true;
        }
        const eventItems = this._crateEventItems({
          accum: 0,
          items: [product],
          listId: pixel.id,
          listName: pixel.name
        });
        gtag("event", "add_to_wishlist", {
          currency: this.currency,
          value: this._centsToMajor((variant == null ? void 0 : variant.price) || product.price),
          items: eventItems
        });
      }
    });
  }
  _handleViewItemList(accum, items, listId, listName) {
    if (items == null ? void 0 : items.length) {
      const eventItems = this._crateEventItems({ accum, items, listId, listName });
      gtag("event", "view_item_list", {
        items: eventItems
      });
    }
  }
  _handleViewItemListUpdate() {
    window.subscribe(window.PUB_SUB_EVENTS.infiniteLoadFinished, ({ accum, data, pixel }) => {
      this._getListProducts();
      this._handleViewItemList(accum, data, pixel.listId, pixel.listName);
    });
  }
  _handleItemListEvent(element) {
    const jsonScript = element.querySelector(`[data-name="json-pixel-products"][type="application/json"]`);
    if (jsonScript) {
      const products = JSON.parse(jsonScript.textContent) || [];
      this._handleViewItemList(0, products, element.dataset.pixelListId, element.dataset.pixelListName);
    }
  }
  _handleItemListAppear() {
    let notAppearList = document.querySelectorAll('[data-pixel-list-appear="false"]');
    if (notAppearList.length) {
      const handleListScroll = () => {
        notAppearList.forEach((element) => {
          if (window.isElementInViewport(element)) {
            element.setAttribute("data-pixel-list-appear", "true");
            this._handleItemListEvent(element);
            notAppearList = document.querySelectorAll('[data-pixel-list-appear="false"]');
            if (!notAppearList.length) {
              window.removeEventListener("scroll", handleListScroll);
            }
          }
        });
      };
      window.addEventListener("scroll", handleListScroll);
    }
  }
  _handleViewItem(item, listId, listName, variantId) {
    var _a;
    if (!item)
      return;
    const variant = (_a = item == null ? void 0 : item.variants) == null ? void 0 : _a.find((v) => v.id == variantId);
    if (variant) {
      variant.selected = true;
    }
    const eventItems = this._crateEventItems({ accum: 0, items: [item], listId, listName });
    gtag("event", "view_item", {
      currency: this.currency,
      value: this._centsToMajor((variant == null ? void 0 : variant.price) || item.price),
      items: eventItems
    });
  }
  _handleSelectItemDelegation() {
    const lists = document.querySelectorAll("[data-pixel-list]");
    lists.forEach((list) => {
      list.addEventListener("click", (event) => {
        var _a;
        const selector = event.target.closest("[data-pixel-selector]");
        if (selector) {
          const { productId } = selector.dataset;
          const product = (_a = this.listProducts) == null ? void 0 : _a.find((p) => p.id == productId);
          if (product) {
            const productCard = selector.closest("product-card");
            if (productCard)
              product.pixelIndex = productCard.dataset.index;
            const listId = list.dataset.pixelListId;
            const listName = list.dataset.pixelListName;
            const eventItems = this._crateEventItems({ accum: 0, items: [product], listId, listName });
            gtag("event", "select_item", {
              button_name: selector.dataset.pixelSelector,
              items: eventItems
            });
          }
        }
      });
    });
  }
  _handleSelectItem(item, listId, listName, variantId) {
    var _a;
    if (!item)
      return;
    const variant = (_a = item == null ? void 0 : item.variants) == null ? void 0 : _a.find((v) => v.id == variantId);
    if (variant) {
      variant.selected = true;
    }
    const eventItems = this._crateEventItems({ accum: 0, items: [item], listId, listName });
    gtag("event", "select_item", {
      currency: this.currency,
      value: this._centsToMajor((variant == null ? void 0 : variant.price) || item.price),
      items: eventItems
    });
  }
}
document.addEventListener("DOMContentLoaded", function() {
  try {
    if (typeof GooglePixelInstance !== "undefined") {
      window.googlePixelInstance = new GooglePixelInstance();
    }
  } catch (error) {
    console.error("Pixel error occurred:", error);
  }
});
